import { Controller } from "@hotwired/stimulus"

// Sets a turbo-frame's src the first time its parent <details> opens.
// Works around the fact that IntersectionObserver (used by Turbo for loading="lazy")
// doesn't reliably fire for frames inside a closed <details>.
export default class extends Controller {
  static targets = ["frame"]
  static values = { src: String }

  toggle(event) {
    if (event.currentTarget.open && this.hasFrameTarget && !this.frameTarget.src) {
      this.frameTarget.src = this.srcValue
    }
  }
}
